import React from 'react';
import { createPortal } from 'react-dom';

interface ToastProps {
    message: string | null;
}

/**
 * Simple fixed-position toast for transient success/info messages.
 */
const Toast: React.FC<ToastProps> = ({ message }) => {
    if (!message) return null;

    return createPortal(
        <div
            className="fixed bottom-8 left-1/2 z-[10002] max-w-md -translate-x-1/2 px-4 pointer-events-none"
            role="status"
            aria-live="polite"
        >
            <div className="pointer-events-auto rounded-xl border border-emerald-500/40 bg-slate-900/95 px-4 py-3 text-center text-sm text-emerald-100 shadow-lg shadow-black/40 backdrop-blur-md">
                {message}
            </div>
        </div>,
        document.body
    );
};

export default Toast;
